module.exports = __webpack_public_path__ + "static/insights-fa1a95958d0c348ec5309ba2f164891d.png";